import React, { forwardRef } from 'react';
import { NavLink, NavLinkProps, useParams } from 'react-router-dom';

import { i18n } from '../i18n';

import { buildLocalePath, DEFAULT_LOCALE, isSupportedLocale } from './localeConfig';

/**
 * Drop-in replacement for React Router's <NavLink> that automatically
 * prepends /:lang prefix to the `to` prop.
 */
export const LocaleNavLink = forwardRef<HTMLAnchorElement, NavLinkProps>(
  ({ to, ...rest }, ref) => {
    const params = useParams<{ lang?: string }>();
    const locale = (params.lang && isSupportedLocale(params.lang))
      ? params.lang
      : (i18n.language || DEFAULT_LOCALE);

    const localeTo = typeof to === 'string'
      ? buildLocalePath(to, locale)
      : typeof to === 'object' && to.pathname
        ? { ...to, pathname: buildLocalePath(to.pathname, locale) }
        : to;

    return <NavLink ref={ref} to={localeTo} {...rest} />;
  },
);

LocaleNavLink.displayName = 'LocaleNavLink';
